var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.isLoading
    ? _c(
        "v-card",
        [
          _c("v-skeleton-loader", {
            staticClass: "mx-auto",
            attrs: { "min-height": _vm.skeletonHeight, type: _vm.skeletonType },
          }),
        ],
        1
      )
    : _c(
        "v-card",
        { attrs: { disabled: _vm.readOnly } },
        [
          _c("v-simple-table", {
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function () {
                  return [
                    _c("thead", [
                      _c("th", { staticClass: "text-left" }),
                      _vm._v(" "),
                      _c("th", { staticClass: "text-left" }),
                      _vm._v(" "),
                      _c("th", { staticClass: "text-right" }),
                    ]),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      { staticClass: "brg-color" },
                      _vm._l(_vm.invoiceItems, function (item, index) {
                        return _c("tr", { key: index }, [
                          _c(
                            "td",
                            [
                              _c("span", { class: _vm.getTextColor(item) }, [
                                _vm._v(_vm._s(item.productName)),
                              ]),
                              _vm._v(" \n          "),
                              _c(
                                "v-btn",
                                {
                                  staticClass: "entity-button-text",
                                  attrs: {
                                    dense: "",
                                    "x-small": "",
                                    depressed: "",
                                    disabled:
                                      _vm.isLoading ||
                                      item.deleted ||
                                      _vm.readOnly,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.editQty(item)
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "v-input txt-blk" },
                                    [
                                      _c("small", [
                                        _vm._v("Qty " + _vm._s(item.quantity)),
                                      ]),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-icon",
                                    {
                                      attrs: {
                                        small: "",
                                        color: "rgba(0,0,0,.60)",
                                      },
                                    },
                                    [_vm._v("mdi-menu-down")]
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("br"),
                              _vm._v(" "),
                              item.relatedAuthor &&
                              item.relatedAuthor.quantity > 0
                                ? _c("span", [
                                    _c("small", [
                                      _vm._v(
                                        "with " +
                                          _vm._s(item.relatedAuthor.quantity) +
                                          " additional Authors at " +
                                          _vm._s(
                                            item.relatedAuthor.unitAmount
                                          ) +
                                          " each"
                                      ),
                                    ]),
                                  ])
                                : _vm._e(),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("td", { staticClass: "mt-n4" }, [
                            _vm._v(_vm._s(item.computedAmountPerPeriod)),
                          ]),
                          _vm._v(" "),
                          _c(
                            "td",
                            [
                              item.deleted
                                ? _c(
                                    "v-tooltip",
                                    {
                                      attrs: { top: "" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "activator",
                                            fn: function ({ on, attrs }) {
                                              return [
                                                _c(
                                                  "v-btn",
                                                  _vm._g(
                                                    _vm._b(
                                                      {
                                                        attrs: {
                                                          disabled:
                                                            _vm.isLoading ||
                                                            _vm.readOnly,
                                                          small: "",
                                                          icon: "",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.restoreProduct(
                                                              item
                                                            )
                                                          },
                                                        },
                                                      },
                                                      "v-btn",
                                                      attrs,
                                                      false
                                                    ),
                                                    on
                                                  ),
                                                  [
                                                    _c("v-icon", [
                                                      _vm._v("mdi-restore"),
                                                    ]),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    },
                                    [
                                      _vm._v(" "),
                                      _c("span", [_vm._v("Restore")]),
                                    ]
                                  )
                                : _c(
                                    "v-tooltip",
                                    {
                                      attrs: { top: "" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "activator",
                                            fn: function ({ on, attrs }) {
                                              return [
                                                _c(
                                                  "v-btn",
                                                  _vm._g(
                                                    _vm._b(
                                                      {
                                                        staticClass:
                                                          "mt-n2 mr-n2",
                                                        attrs: {
                                                          disabled:
                                                            _vm.isLoading ||
                                                            _vm.readOnly,
                                                          small: "",
                                                          icon: "",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.removeProduct(
                                                              item
                                                            )
                                                          },
                                                        },
                                                      },
                                                      "v-btn",
                                                      attrs,
                                                      false
                                                    ),
                                                    on
                                                  ),
                                                  [
                                                    _c(
                                                      "v-icon",
                                                      {
                                                        attrs: {
                                                          small: "",
                                                          color: "red",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "mdi-trash-can-outline"
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    },
                                    [
                                      _vm._v(" "),
                                      _c("span", [_vm._v("Remove")]),
                                    ]
                                  ),
                            ],
                            1
                          ),
                        ])
                      }),
                      0
                    ),
                  ]
                },
                proxy: true,
              },
            ]),
          }),
          _vm._v(" "),
          _vm.qtyDialog
            ? _c(
                "v-dialog",
                {
                  attrs: { width: "356" },
                  model: {
                    value: _vm.qtyDialog,
                    callback: function ($$v) {
                      _vm.qtyDialog = $$v
                    },
                    expression: "qtyDialog",
                  },
                },
                [
                  _c(
                    "v-card",
                    [
                      _c(
                        "v-toolbar",
                        { attrs: { dense: "" } },
                        [
                          _c("v-toolbar-title", [_vm._v("Update quantity")]),
                          _vm._v(" "),
                          _c("v-spacer"),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              attrs: { icon: "" },
                              on: {
                                click: function ($event) {
                                  _vm.qtyDialog = false
                                },
                              },
                            },
                            [_c("v-icon", [_vm._v("mdi-close")])],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-card-text",
                        { staticClass: "mt-6" },
                        [
                          _c("quantity", {
                            attrs: {
                              totalQty: _vm.editedQty.quantity,
                              additionalQty: _vm.additionalQty,
                              learnerAuthorList:
                                _vm.editedQty.learnerAuthorList,
                              authorOnly: _vm.editedQty.authorOnly,
                              learner: _vm.editedQty.learner,
                              isSilver: _vm.isSilver(_vm.editedQty),
                              isLearner: _vm.editedQty.showQtySelect,
                            },
                            on: {
                              updateError: _vm.updateError,
                              updateQty: _vm.updateQty,
                              toLearner: _vm.toLearner,
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-card-actions",
                        [
                          _c("v-spacer"),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                color: "secondary",
                                block: "",
                                disabled: _vm.hasError,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.updateItemQty()
                                },
                              },
                            },
                            [_vm._v("\n          Update\n        ")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }